'use client';

import { styled } from '@mui/material/styles';

export const BpIcon = styled('span')`
  border-radius: 50%;
  width: 16px;
  height: 16px;
  box-shadow:
    inset 0 0 0 1px rgba(16, 22, 26, 0.2),
    inset 0 -1px 0 rgba(16, 22, 26, 0.1);
  background-color: #f5f8fa;
  background-image: linear-gradient(180deg, hsla(0, 0%, 100%, 0.8), hsla(0, 0%, 100%, 0));
  transition: background-image 150ms cubic-bezier(0.4, 0, 0.2, 1);

  .Mui-focusVisible & {
    outline: 2px auto rgba(19, 124, 189, 0.6);
    outline-offset: 2px;
  }

  input:hover ~ & {
    background-color: #ebf1f5;
  }

  input:disabled ~ & {
    box-shadow: none;
    background: ${({ theme }) => theme.vars.palette.disabled.main};
  }
`;

export const BpCheckedIcon = styled(BpIcon)`
  background-color: ${({ theme }) => theme.vars.palette.primary.dark};
  background-image: linear-gradient(180deg, hsla(0, 0%, 100%, 0.1), hsla(0, 0%, 100%, 0));
  transition: background-image 150ms cubic-bezier(0.4, 0, 0.2, 1);

  &:before {
    display: block;
    width: 16px;
    height: 16px;
    background-image: radial-gradient(#fff, #fff 28%, transparent 32%);
    content: '';
  }

  input:hover ~ & {
    background-color: ${({ theme }) => theme.vars.palette.primary.main};
  }
`;
